export const klaroConfig = {
  version: 1,
  elementID: "klaro",
  lang: "ro",
  storageMethod: "cookie",
  storageName: "klaro",
  cookieExpiresAfterDays: 365,
  default: false,
  acceptAll: true,
  hideDeclineAll: false,
  hideLearnMore: false,
  mustConsent: false,
  noticeAsModal: false,
  noNotice: true,
  hideToggleAll: true,
  groupByPurpose: false,
  htmlTexts: true,
  translations: {
    zz: {
      privacyPolicyUrl: "/politica-cookie",
    },
    ro: {
      acceptAll: "Acceptă toate",
      acceptSelected: "Doar cookie‑urile selectate",
      decline: "Nu accepta",
      ok: "Acceptă esențial",
      save: "Salvează",
      learnMore: "Află mai multe",
      close: "Închide",
      privacyPolicy: {
        name: "Politica de cookie‑uri",
        text: "Citește {privacyPolicy}.",
      },
      consentNotice: {
        description:
          "Folosim cookie‑uri tehnice pentru a îmbunătăți experiența. Acestea sunt necesare pentru funcționarea corectă a site‑ului. Prin utilizarea site‑ului ești de acord cu {privacyPolicy}.",
        learnMore: "Află mai multe",
      },
      consentModal: {
        title: "Setări cookie",
        description:
          "Tu decizi ce tipuri de cookie‑uri folosim. Unele sunt necesare, iar altele ne ajută să îmbunătățim experiența. Poți ajusta oricând preferințele aici.",
      },
      purposeItem: {
        service: "serviciu",
        services: "servicii",
      },
      purposes: {
        analytical: "Analytical",
        preference: "Preference",
        marketing: "Marketing",
        essential: "Esențiale",
      },
      analytical: {
        title: "Analytical",
        description:
          "Ne ajută să înțelegem ce funcționează bine și unde putem îmbunătăți experiența.",
      },
      preference: {
        title: "Preference",
        description:
          "Țin minte alegerile tale, astfel încât site‑ul să fie mai personal pentru tine.",
      },
      marketing: {
        title: "Marketing",
        description:
          "Ne ajută să îți arătăm conținut și oferte relevante, fără a fi intruzive.",
      },
    },
  },
  services: [
    {
      name: "essential",
      title: "Esențiale",
      purposes: ["essential"],
      description:
        "Necesare pentru funcționarea corectă a site‑ului și pentru siguranță.",
      default: true,
      required: true,
      optOut: false,
    },
    {
      name: "preference",
      title: "Preference",
      purposes: ["preference"],
      description:
        "Țin minte alegerile tale, astfel încât site‑ul să fie mai personal pentru tine.",
      default: false,
      required: false,
      optOut: false,
    },
    {
      name: "marketing",
      title: "Marketing",
      purposes: ["marketing"],
      cookies: [/^_fbp/, /^_fbc/],
      description:
        "Ne ajută să îți arătăm conținut și oferte relevante, fără a fi intruzive.",
      default: false,
      required: false,
      optOut: false,
    },
  ],
};
